<template>
  <div class="order-container">
    <el-card>
      <div slot="header">
        <span>激活码信息</span>
      </div>

      <!-- 搜索区域 -->
      <div class="search-box" style="margin-bottom: 20px;">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" @submit.native.prevent>
          <el-form-item label="课程名">
            <el-input 
              v-model="searchForm.courseName" 
              placeholder="请输入课程名" 
              clearable
              style="width: 200px;"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search" @keyup.enter="handleSearch">搜索</el-button>
            <el-button @click="handleReset" icon="el-icon-refresh-left">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 用户表格 -->
      <el-table :data="tableData" v-loading="loading" style="width: 100%" border>
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="coursename" label="课程名"></el-table-column>
        <el-table-column prop="type" label="课程类型">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.type === '0' ? 'primary' : 'success'"
              disable-transitions>{{scope.row.type === '0' ? '专业课' : '公共课'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="serialcode" label="激活码"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 0 ? 'danger' : ''"
              disable-transitions>{{scope.row.status === 0 ? '被使用' : '未使用'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="创建时间"></el-table-column>
      </el-table>

      <!-- 分页（可选） -->
      <div class="pagination" style="margin-top: 20px; text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="prev, pager, next, total, sizes"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'Orders',
  data() {
    return {
      loading: false,
      tableData: [],
      order: "",
      // 分页相关（暂不启用）
      page: 1,
      pageSize: 10,
      total: 0,

      // 搜索表单
      searchForm: {
        courseName: ''
      }
    }
  },
  filters: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  },
  created() {
    this.fetchCodeList();
  },
  methods: {

    async fetchCodeList() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          courseName: this.searchForm.courseName || undefined,
        };
        const {data: res}= await this.$http.get('get_serialcode_list', {params});
        this.tableData = res.data
        this.total = res.total
      } catch (error) {
        this.$message.error('获取订单列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    // 搜索
    async handleSearch() {
      const valid = await this.$refs.searchForm.validate().catch(() => false);
      if (!valid) {
        this.$message.warning('请输入课程名');
        return;
      }
      this.page = 1; // 搜索时重置到第一页
      this.fetchCodeList();
    },

    // 重置搜索条件
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        courseName: ''
      };
      this.page = 1;
      this.fetchCodeList();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.fetchCodeList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchCodeList();
    },
    sortChange(val) {
      this.order = val.order;
      this.fetchCodeList()
    }
  }
}
</script>

<style lang="less">
.order-container {
  padding: 20px;
}

.password_show {
  .el-input__inner {
    border: none;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>